export enum EstadoProceso {
  INICIAL = 'INICIAL',
  PENDIENTE = 'PENDIENTE',
  CARGANDO = 'CARGANDO',
  FINALIZADO_EXITOSAMENTE = 'FINALIZADO_EXITOSAMENTE',
  FINALIZADO_PARCIALMENTE = 'FINALIZADO_PARCIALMENTE',
  FINALIZADO_CON_ERRORES = 'FINALIZADO_CON_ERRORES',
  DATOS_NO_ENCONTRADOS = 'DATOS_NO_ENCONTRADOS',
}
